import type { ServerFile } from "../types/ServerFile";

export const validateNumNational = (value:string,translator : (e:string)=>string) => {
       
        if(value.length!=11){
            return translator("num_national_error_length");
            //too short
            //return;
        }
        if(!/^\d+$/.exec(value) ){
            //only numbers
            return translator("num_national_error_char");
            //return;
        }
        let base=parseInt(value.substring(0,9));
        const checksum=parseInt(value.substring(9));
        
       
        if(!(base % 97 == 97 - checksum)){
            if(parseInt(value.substring(0,2))<2025){
                base=parseInt("2" + value.substring(0,9));
                if (base % 97 == 97 - checksum) {
                    return true;
                }
            }
            return translator("num_national_error_invalid");
           // return;
        }
        return true;
    }
export  const validateDateNaissance = (value:string |number | undefined | number[] | ServerFile,translator : (e:string)=>string)  => {
 
        if(!value){
           return translator("date_naissance_error_requis");
        }
        if(!(typeof value === 'string')){
            return translator("date_naissance_error_value");
        }
        if(typeof value === 'string' && !/\d{4}-\d{2}-\d{2}/.exec(value)){
            return translator("date_naissance_error_date");
        }
        const year= new Date().getFullYear();
        if(typeof value === 'string' && (parseInt(value.split('-')[0]) > year -18 || parseInt(value.split('-')[0]) < year -140) ) {
            return translator("date_naissance_error_age");
        }
        return true;
    }


export const validateIBAN = (iban: string,translator : (e:string)=>string): string | true => {

    if(iban.startsWith('BE')){
        return validateIBAN_BE(iban,translator);
    }else{
        return translator("iban_error_format_BE");
    }
}

const validateIBAN_BE = (iban:string,translator : (e:string)=>string): string | true =>{
    if(iban.length!=16){
        return translator("iban_error_invalid_size");
    }
    const checksum=parseInt(iban.substring(14,16));
    const base=parseInt(iban.substring(4,14));
    if(base % 97 != checksum){
        return translator("iban_error_checksum");
    }
    return true;

}

export const validateTelephone=(tel:string,translator : (e:string)=>string): string | true =>{
    if (!/^[0-9]+$/.test(tel)) {
        return translator("tel_error_invalid_chars");
    }
    if(tel.length!=9 && tel.length!=10){
        return translator("tel_error_invalid_size");
    }
    if (!tel.startsWith("0")) {
        return translator("tel_error_invalid_zero");
    }
   
    return true;
}

export const validatePassword = (password: string,translator : (e:string)=>string): string | true => {

        if (!/[A-Z]/.test(password)) {
            return translator("Le mot de passe doit contenir au moins une lettre majuscule.");
        }
        if (!/[a-z]/.test(password)) {
            return translator("Le mot de passe doit contenir au moins une lettre minuscule.");
        }       
        if (!/[0-9]/.test(password)) {
            return translator("Le mot de passe doit contenir au moins un chiffre.");
        }
        if (!/[^A-Za-z0-9]/.test(password)) {
            return translator("Le mot de passe doit contenir au moins un caractère spécial.");
        }
        if (password.length < 8) {
            return translator("Le mot de passe doit contenir au moins 8 caractères.");
        }
        return true;
    }